import React, { useState, useEffect, } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Spinner from "../../Spinner";
import { useLocation, } from 'react-router';

import { Row, Card, Button, Col } from 'antd';
import notification from '../../../services/notification';
import { UserPlusIcon, } from "@phosphor-icons/react";
import { AddUserModal, UserGridView } from '../index';
import { UserList } from '../../../services/users';

const UsersView = ({
    dataLoading,
    history,
    customerID = "me",
    ...props
}) => {

    const [userListData, setUserListData] = useState([]);
    const [userListLoading, setUserListLoading] = useState(true);
    const [addUserOpen, setAddUserOpen] = useState(false);
    const intl = useIntl();
    const { pathname } = useLocation();

    // loading users
    useEffect(() => {
        LoadUserList();
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    const LoadUserList = () => {
        setUserListLoading(true);
        UserList(customerID, history)
            .then(response => {
                if (response.status) {
                    setUserListData(response.data.user_list);
                    setUserListLoading(false);
                } else {
                    history('/dashboard');
                    console.warn('error:', response)
                    notification['warning']({
                        message: 'User details',
                        description: "Error on requesting profile settings data",
                    });
                }
            })
            .catch(error => {
                notification['error']({
                    message: 'Account',
                    description: intl.formatMessage({ id: "UNKNOW_ERROR" }),
                });
            });
    };

    if (dataLoading && userListLoading) return <Spinner />;

    return (
        <React.Fragment>
            <Row gutter={[32, 32]}>
                <Col span={24}>

                    <Card
                        title={<h4 className="card-title">
                            {pathname.includes('profile') ? (
                                <FormattedMessage id="profile-users-header" />
                            ) : (
                                <FormattedMessage id="customer-users-header" />
                            )}
                        </h4>}
                        className="my-4"
                        styles={{ body: { paddingLeft: '0px', paddingRight: '0px' } }}
                        extra={[
                            <Button
                                key="1"
                                className="ant-btn-success"
                                onClick={() => { setAddUserOpen(!addUserOpen) }}
                                icon={<UserPlusIcon size={16} weight="light" className="mr-1" />}>
                                <FormattedMessage id="user-add" />
                            </Button>,
                        ]}>

                        <UserGridView
                            dataLoading={userListLoading}
                            dataTable={userListData}
                            refreshData={LoadUserList}
                            history={history}
                            {...props}
                        />

                    </Card>
                </Col>
            </Row>

            {addUserOpen && (
                <AddUserModal
                    modalIsOpen={addUserOpen}
                    modalIsOpenHandler={setAddUserOpen}
                    customerID={customerID}
                    refreshData={LoadUserList}
                    history={history}
                    {...props}
                />
            )}

        </React.Fragment>
    );
};


export default UsersView;